import { GlLink, GlSprintf, GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
import { FOUNDATIONAL_FLOW_REFERENCE_CODE_REVIEW } from '../constants';
import { getRegistryItem } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/item_type_registry.js?vue3';
import AiCatalogItemField from './ai_catalog_item_field.vue';
import ServiceAccountProjectMemberships from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/service_account_project_memberships.vue?vue3';
import ServiceAccountAvatar from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/service_account_avatar.vue?vue3';
export default {
    name: 'AiCatalogItemFieldServiceAccount',
    components: {
        GlLink,
        GlSprintf,
        GlButton,
        AiCatalogItemField,
        ServiceAccountProjectMemberships,
        ServiceAccountAvatar
    },
    props: {
        serviceAccount: {
            type: Object,
            required: true
        },
        itemType: {
            type: String,
            required: true
        },
        foundationalFlowReference: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            isDrawerOpen: false
        };
    },
    computed: {
        itemRegistry () {
            return getRegistryItem(this.itemType);
        },
        itemTypeLabel () {
            return this.itemRegistry.label;
        },
        isCodeReviewFoundational () {
            return this.foundationalFlowReference === FOUNDATIONAL_FLOW_REFERENCE_CODE_REVIEW;
        },
        helpMessage () {
            if (this.isCodeReviewFoundational) {
                return s__('AICatalog|This %{linkStart}service account%{linkEnd} is created automatically and used internally by the Code Review flow. To trigger the flow, assign %{boldStart}@GitLabDuo%{boldEnd} as a reviewer on a merge request — do not assign or mention this account.');
            }
            return s__('AICatalog|%{linkStart}Service accounts%{linkEnd} represent non-human entities. This is the account that you mention or assign to trigger the %{itemType}.');
        }
    },
    methods: {
        openDrawer () {
            this.isDrawerOpen = true;
        },
        closeDrawer () {
            this.isDrawerOpen = false;
        }
    },
    serviceAccountsDocsLink: helpPagePath('user/profile/service_accounts')
};
